import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const Footer = () => {
  const { platformData } = useSelector(state => state.frontend);
  const location = useLocation();

  const shouldHideFooter =
    location.pathname.includes("/dashboard") ||
    location.pathname.includes("/auth") ||
    location.pathname.includes("/chatembed") ||
    location.pathname.includes("/embed");

  if (shouldHideFooter) return null;

  // Don't render if no platform data or no links configured
  const hasLegalLinks = platformData?.userTermsConditions || platformData?.privacyPolicy;
  const hasAppLinks = platformData?.iosAppUrl || platformData?.androidAppUrl;

  if (!platformData || (!hasLegalLinks && !hasAppLinks)) {
    return null;
  }

  const footerStyle = {
    backgroundColor: platformData.lightColor || "#f3f3f3",
    color: platformData.darkColor || "#333333"
  };

  const linkStyle = {
    color: platformData.darkColor || "#333333",
    transition: "color 0.2s ease"
  };

  const linkHoverStyle = {
    color: platformData.primaryColor || "#0000ff"
  };

  return (
    <footer className="py-6 mt-auto" style={footerStyle}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* App Store Links - Centered on first line */}
        {hasAppLinks && (
          <div className="flex justify-center items-center gap-3 mb-4">
            {platformData.iosAppUrl && (
              <a
                href={platformData.iosAppUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block hover:opacity-80 transition-opacity"
              >
                <img src="/appstore.svg" alt="Download on the App Store" width="150" height="50" />
              </a>
            )}
            {platformData.androidAppUrl && (
              <a
                href={platformData.androidAppUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block hover:opacity-80 transition-opacity"
              >
                <img src="/googleplay.svg" alt="Get it on Google Play" width="150" height="50" />
              </a>
            )}
          </div>
        )}

        {/* Legal Links and Copyright - Same line */}
        <div className="flex justify-center items-center gap-4 text-sm">
          {platformData.name && (
            <span className="opacity-70" style={{ color: platformData.darkColor || "#333333" }}>
              © {new Date().getFullYear()} {platformData.name}
            </span>
          )}
          {platformData.name && hasLegalLinks && (
            <span style={{ color: platformData.darkColor || "#333333" }}>•</span>
          )}
          {platformData.privacyPolicy && (
            <a
              href={platformData.privacyPolicy}
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
              onMouseEnter={e => (e.target.style.color = linkHoverStyle.color)}
              onMouseLeave={e => (e.target.style.color = linkStyle.color)}
            >
              Privacy Policy
            </a>
          )}
          {platformData.userTermsConditions && platformData.privacyPolicy && (
            <span style={{ color: platformData.darkColor || "#333333" }}>•</span>
          )}
          {platformData.userTermsConditions && (
            <a
              href={platformData.userTermsConditions}
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
              onMouseEnter={e => (e.target.style.color = linkHoverStyle.color)}
              onMouseLeave={e => (e.target.style.color = linkStyle.color)}
            >
              Terms of Service
            </a>
          )}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
